import React, { useEffect, useState } from "react";
import api from "../utils/api";
import TransactionTable from "./TransactionTable";
import UploadCSV from "./UploadCSV";
import ManualTransactionForm from "./ManualTransactionForm";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Tabs from "./Tabs";
import Footer from "./Footer";

export default function Dashboard({ setLoggedIn }) {
  const [transactions, setTransactions] = useState([]);
  const [year, setYear] = useState(null); // <-- initially null
  const [summary, setSummary] = useState({ total_income: 0, total_expense: 0 });
  const [availableYears, setAvailableYears] = useState([]);
  const navigate = useNavigate();

  // Fetch ALL transactions to determine available years
  const fetchAllTransactions = async () => {
    try {
      const res = await api.get(`/transactions`); // <-- fetch without year filter
      const allTransactions = res.data || [];

      // Extract unique years
      const years = [
        ...new Set(allTransactions.map((t) => new Date(t.date).getFullYear())),
      ].sort((a, b) => b - a);

      // Set dropdown years
      setAvailableYears(years);

      // Default to most recent year if no year is selected
      if (!year && years.length > 0) {
        setYear(years[0]);
      }
    } catch (err) {
      console.log(err);
      if (err.response.data.message === "Invalid token") {
        localStorage.removeItem("token");
        setLoggedIn("");
        navigate("/");
      } else {
        toast.error("Failed to load transactions");
      }
    }
  };

  const fetchTransactions = async (selectedYear) => {
    if (!selectedYear) return;
    try {
      const res = await api.get(`/transactions?year=${selectedYear}`);
      setTransactions(res.data || []);
    } catch {
      toast.error("Failed to load transactions");
    }
  };

  const fetchSummary = async (selectedYear) => {
    if (!selectedYear) return;
    try {
      const res = await api.get(`/transactions/summary?year=${selectedYear}`);
      setSummary(res.data);
    } catch {
      toast.error("Failed to load summary");
    }
  };

  const handleTransactionUpdated = () => {
    fetchAllTransactions();
    if (year) {
      fetchTransactions(year);
      fetchSummary(year);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return navigate("/");

    // First fetch all transactions to determine years
    fetchAllTransactions();
  }, []);

  useEffect(() => {
    if (year) {
      fetchTransactions(year);
      fetchSummary(year);
    }
  }, [year]);

  return (
    <div className="container mt-5">
      <h2>My Transactions</h2>

      {/* Year Filter */}
      <div className="mb-3">
        <label>Select Year:</label>
        <select
          className="form-select w-auto"
          value={year || ""}
          onChange={(e) => setYear(parseInt(e.target.value))}
        >
          {availableYears.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      {/* Summary */}
      <div className="mb-3">
        <strong>Total Income:</strong> ${summary.total_income || 0} <br />
        <strong>Total Expense:</strong> ${summary.total_expense || 0}
      </div>

      <UploadCSV onUpload={handleTransactionUpdated} />
      <ManualTransactionForm onTransactionAdded={handleTransactionUpdated} />

      <Tabs
        transactions={transactions}
        onTransactionUpdated={handleTransactionUpdated}
      />
      <Footer />
    </div>
  );
}
